export enum IntakeFormSectionType {
  STANDARD = 'STANDARD',
  CALCULATED = 'CALCULATED'
}
